import React from 'react'

const SvgTwitter = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width='12'
    height='11.234375'
    viewBox='0 0 12 11.234375'
  >
    <g>
      <g>
        <g>
          <path
            d='M0.0285117,0.00000174021L4.66223,6.19502L0,11.2325L1.04923,11.2325L5.13096,6.82228L8.4292,11.2325L12,11.2325L7.10625,4.68846L11.4469,0L10.3976,0L6.63752,4.0612L3.59932,0L0.0285117,0.00000174021ZM1.57156,0.773238L3.2127,0.773238L10.4569,10.4604L8.81581,10.4604L1.57156,0.773238Z'
            fill='#333333'
            fillOpacity='1'
            style={{ mixBlendMode: 'passthrough' }}
          />
        </g>
      </g>
    </g>
  </svg>
)

export default SvgTwitter
